import { createClient } from '@supabase/supabase-js';

// Supabase Configuration
const SUPABASE_URL = 'https://gwvfrsforsbagoiktymr.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd3dmZyc2ZvcnNiYWdvaWt0eW1yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzg1OTY1MjMsImV4cCI6MjA1NDE3MjUyM30.XpQ7My8UOlx9hLyOBwlVn2aZQG8QHM2ePqmO3DYOKHo';

// Initialize Supabase client with improved configuration
let supabase;

try {
    supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
        realtime: {
            params: {
                eventsPerSecond: 10
            },
            timeout: 20000,
            heartbeat: {
                interval: 5000,
                maxRetries: 5
            }
        },
        auth: {
            autoRefreshToken: true,
            persistSession: true
        },
        db: {
            schema: 'public'
        }
    });

    console.log('Supabase client initialized successfully');
} catch (error) {
    console.error('Error initializing Supabase:', error);
    // Create a fallback client with minimal configuration
    supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
}

// Export the client for use in other files
export default supabase;